/* unplugin-vue-components disabled */
import SymbolCounter from './symbol-counter'

export default {
  components: {SymbolCounter},
  mixins: [ModelValue(String)],
  props: {
    placeholder: {type: String, default: '', required: false},
    disabled: {type: Boolean, default: false},
    rows: {type: [String, Number], default: '1', required: false},
    maxlength: {type: Number, default: undefined},
    minlength: {type: Number, default: undefined},
    description: {type: String, required: false, default: ''},
    required: {type: Boolean, default: false},
    spellcheck: {type: Boolean, default: true},
    autoresize: {type: Boolean, default: false},
    error: {type: String, default: undefined},
    footnote: {type: Boolean, default: true},
    counter: {type: Boolean, default: true},
    type: {type: String, default: 'textarea'},
    validator: {type: Function, default: undefined},
  },
  emits: ['blur', 'right-icon', 'update:valid'],
  data() {
    return {
      valid: true,
      internal_rows: 1
    }
  },
  computed: {
    counter_value() {
      if (this.type === 'textarea-kb') return new TextEncoder().encode(this.value).length / 1024
      return this.value.length
    },
    size_valid() {
      if (this.counter_value < this.minlength) return false
      if (this.counter_value > this.maxlength) return false
      return true
    },
    has_validation() {
      if (this.type ===  'textarea-kb') return this.maxlength !== undefined
      return this.required || this.minlength > 0
    },
    c_counter(){
      if (this.counter) return true
      return this.maxlength === undefined
    },
    error_text () {
      if (this.valid) return
      if (!this.value && this.required) return '\n'
      if (this.error) return this.error
      if (this.type === 'textarea-kb') {
        if (this.counter_value < this.minlength) return `Should be at least ${this.minlength} KB`
        if (this.counter_value > this.maxlength) return `Should be not more than ${this.maxlength} KB`
      }
      if (this.type === 'textarea-json') return 'Input must be a valid JSON'

      const validity = this.$refs.textarea.validity
      if (validity.tooShort) return `Should be at least ${this.minlength} characters long`
      if (validity.tooLong) return `Should be not more than ${this.maxlength} characters long`
      if (validity.valueMissing) return '\n'

      return 'Invalid value provided'
    },
    c_rows() {
      if (this.autoresize) return this.internal_rows
      return this.rows
    },
  },
  watch: {
    value(next, prev) {
      this.checkValidity()

      if (this.autoresize) {
        this.startUpdateRows()
      }

      const dif = next.length - prev.length
      if (dif > 1) {
        this.$nextTick(() => this.focusEnd())
      }
    }
  },
  mounted() {
    if (this.autoresize) this.startUpdateRows()
    this.checkValidity()
  },
  methods: {
    checkValidity() {
      this.valid = !this.valid // this is to force dependent error_text recalc
      if (!this.value) this.valid = !this.required
      else if (this.type === 'textarea-kb') {
        this.valid = this.size_valid && (!this.validator || this.validator(this.value))
      }
      else if (this.validator) this.valid = this.validator(this.value)
      else if (this.type === 'textarea-json') this.valid = $utils.validate.isJsonString(this.value)
      else this.valid = this.$refs.textarea?.checkValidity()
    },
    startUpdateRows(){
      this.internal_rows = 1
      this.$nextTick(() => this.updateRows())
    },
    focusEnd() {
      const textarea = this.$refs.textarea
      const end = this.value.length
      textarea.focus()
      textarea.setSelectionRange(end, end)
    },
    updateRows() {
      const textarea = this.$refs.textarea
      if (textarea.clientHeight < textarea.scrollHeight) {
        this.internal_rows += 1
        this.$nextTick(this.updateRows)
      }
    }
  }
}
